import React, {Component} from 'react';
import { withTranslation } from "react-i18next";
import { AppFooter } from './LayoutComponents/AppFooter';
import 'primereact/resources/themes/saga-blue/theme.css';
//import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '../layout/layout.scss';
import '../App.scss';
import { NavLink } from 'react-router-dom';

class Loadding extends Component {

    render() {
        const { t } = this.props;
        return (
            <div  >
                <div className="layout-main">
                    <div className="layout-logo center" >
                        <NavLink activeClassName="active-route" to={'/'} exact={true}>
                            <img alt="Logo"  style={{width:'20%',cursor: 'pointer'}} src='assets/layout/images/Logo_Enerland_1.png' />
                        </NavLink>
                    </div>
                        <div className="p-col-12">
                            <div className="card center">
                                <h1>{t("Cargando")}</h1></div>
                                <div className="card center">
                                <img alt="Logo" style={{width:'200px',cursor: 'pointer'}} src='assets/layout/images/loadding.svg' />
                            </div>
                        </div>
                </div>
                <AppFooter />
                <div className="layout-mask"></div>
            </div>
        );
    }
};
export default withTranslation ("translations") (Loadding);